import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton, Table } from "react-bootstrap";
import SidebarLayout from "../components/shared/SidebarLayout";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { compact, isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import obj from "../Utils/helpers";
const Logs = () => {
  const [data, setData] = useState([]);
  const [listing, setListing] = useState([]);
  const getData = async () => {
    const { status, data } = await apiGet(apiPath.activityLogs);
    if (data?.success) {
      setListing(data?.results?.data);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <SidebarLayout heading={"Active Log"}>
      {/* <div className="select-container">
        <DropdownButton id="dropdown-basic-button" title="Active Log">
          <Dropdown.Item href="#/action-1">Active Log</Dropdown.Item>
          <Dropdown.Item href="#/action-2">Change Password Log</Dropdown.Item>
        </DropdownButton>
      </div> */}
      <div className="p-sm-3 p-2 pt-3">
        <div className="active-log-table">
          {listing?.length > 0
            ? listing?.map((item, index) => {
                return (
                  <Table
                  style={{ borderRadius: ".5rem" }}
                  bordered
                  className=" overflow-hidden bg-white"
                >
                    <thead>
                      <tr>
                        <th  style={{
                            fontWeight: "400",
                            fontSize: ".8571428571428571rem",
                            padding: ".3rem .5rem",
                          }} colSpan="4">{obj.dateFormat(item?.createdAt)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="4">
                          Login Status{" "}
                          <strong
                            className="d-block"
                            style={{ color: "green" }}
                          >
                            {item?.activityStatus}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td width="40%">IP Address</td>
                        <td width="60%">{item?.ip}</td>
                      </tr>
                      <tr>
                        <td width="40%">ISP</td>
                        <td width="60%">{item?.isp || "--"}</td>
                      </tr>
                      <tr>
                        <td width="40%">City/State/Country</td>
                        <td width="60%">{item?.country}</td>
                      </tr>
                    </tbody>
                  </Table>
                );
              })
            : ""}
        </div>
      </div>
    </SidebarLayout>
  );
};

export default Logs;
